// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-UEief";
var _4 = "price-3cqwe";
var _5 = "details-6x0Js";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "price", _5 as "details" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "price": _4, "details": _5 }
